module.exports = __webpack_public_path__ + "img/vipprice.48c96bf2.png";